// 战队信息
export default [
    {
      path: '/team-rank',
      name: 'team-rank',
      component: () => import('@/views/team/rank/index.vue'),
    },
    {
      path: '/team-user',
      name: 'team-user-detail',
      component: () => import('@/views/team/user-detail/index.vue'),
    },
  ]
  